import { Component } from '@angular/core'

@Component({
  selector: 'kdgh-page-actions',
  templateUrl: './page-actions.component.html',
  styleUrls: ['./page-actions.component.scss'],
})
export class PageActionsComponent {}
